/**
 * Shared layout constants for the stack-unfurl module.
 *
 * Currently a single tunable, but kept in its own file so the
 * geometry tracer (`stack-frame.tsx`) and any future row-aware
 * helpers can share the exact same "same row" tolerance without one
 * accidentally drifting from the other.
 */
/** Tolerance (in CSS pixels) for "same row" when bucketing in-stack
 *  item rects by their `top`. Used by `computeStackFrameGeometry` to
 *  decide which items belong to a single horizontal strip of the
 *  polygon outline. */
export const ROW_EPSILON = 1;
